export default (payloads) => {
  return payloads.map((payload) => {
    return {
      ...payload,
      data: payload.payload,
      type: payload.payload.payloadType,
    };
  });
};
